import { ChangeDetectorRef, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { DiscountService } from './discount.service';
import { TableKeyEnum } from '../../../core/enum/table-key.enum';
import { MatTableDataSource } from '@angular/material';
import { Subscription } from 'rxjs';
import { SearchControlTypeEnum, SearchDataTypeEnum } from '../../../core/enum/searchType.enum';
import { SearchService } from '../../../services/search.service';
import { OldAbstractBaseListComponent } from '../../../components/base/old-abstract-base-list-component';
import { AclConstants } from '../../aclOperationConstants';
import { AclClassConstants } from '../../aclClassConstants';
import { LoginService } from '../../login/login.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-discount',
  templateUrl: './discount.component.html',
  styleUrls: ['./discount.component.scss']
})
export class DiscountComponent extends OldAbstractBaseListComponent implements OnInit {
  @ViewChild('statusWrapper', { static: false }) statusWrapperRef: TemplateRef<any>;
  @ViewChild('actionBtn', { static: false }) actionBtnRef: TemplateRef<any>;
  @ViewChild('discountName', { static: false }) discountNameReff: TemplateRef<any>;
  AclClassConstants = AclClassConstants;
  AclConstants = AclConstants;
  discountDataForGrid:any = {content:[]};
  discountGridSettings: any = {};
  show_update:any = false;
  selectForUpdate: any;
  // config for n-table
  tableKeyEnum = TableKeyEnum;
  allColumns: any[] = [];
  dataSource = new MatTableDataSource([]);
  filteredDiscountDataForGrid : any = [];
  discountNeoGridSettings : any = {};
  // For advance search
  searchSettings = [];
  subscriptions: Subscription[] = [];
  filteredDicountDataForGrid: any = [];
  public loginService: LoginService;

  constructor(
    private discountService: DiscountService,
    private router: Router,
    private sanitizer: DomSanitizer,
    private cdRef:ChangeDetectorRef,
    private searchService: SearchService,
    private tosterservice:ToastrService,
    loginService: LoginService
  ) {
    super(searchService);
    this.loginService = loginService;
  }

  setGridSetting() {
    let self = this;
    this.allColumns = [
      {
        colKey: 'index',
        default: 'ID',
        rowKey: 'id',
        width: '3%',
        isFilterAllow: false,
        isNumber: true,
      },
      {
        colKey: 'name',
        default: 'Discount Name',
        rowKey: 'name',
        width: '10%',
        isNumber: false,
        isFilterAllow: true,
        enableEdit: true,
        enableDelete: true,
        enableSort: true,
      },
      {
        colKey: 'status',
        default: 'STATUS',
        rowKey: 'status',
        width: '10%',
        customControls: [this.statusWrapperRef],
        customValue:(status) => {
          if(status === 'Y'){
            return 'Active';
          } else {
            return 'InActive';
          }
        },
        isNumber: false,
        isFilterAllow: true,
        enableEdit: true,
        enableDelete: true,
        enableSort: true,
      },
      {
        colKey: 'updatedate',
        default: 'Last Modified',
        rowKey: 'updatedate',
        width: '10%',
        isNumber: false,
        isFilterAllow: true,
        enableEdit: true,
        enableDelete: true,
        enableSort: true,
      },
      {
        colKey: 'actionCol',
        default: 'Action',
        rowKey: 'id',
       //enableEdit: true,
        // enableDelete: true,
        enableEdit: false,
        enableDelete: false,
        isFilterAllow: false,
        enableSort: false,
        isExpandable: false,
        isNumber: false,
        width: '1%',
        isStickyEnd: true,
      },
    ];
    this.allColumns.forEach(element => {
      element.isFilterAllow = false;
    });
    this.searchSettings = [
      {
        display_field: 'Discount Name',
        value_field: 'name',
        control_setting: [
          {
            control_type: SearchControlTypeEnum.TEXT,
            display_style: '',
          },
        ],
        data_type: SearchDataTypeEnum.STRING,
      },
      {
        display_field: 'Status',
        value_field: 'status',
        control_setting: [
          {
            control_type: SearchControlTypeEnum.SELECT,
            display_style: '',
          },
        ],
        data_type: SearchDataTypeEnum.BOOLEAN,
        select_items: [
          {
            display_field: 'All',
            value_field: ['Y', 'N'],
          },
          {
            display_field: 'Active',
            value_field: 'Y',
          },
          {
            display_field: 'In Active',
            value_field: 'N',
          },
        ],
      },
    ];

    this.discountNeoGridSettings = {
      showAdvanceSearch: false,
      showFooter: false,
      showPagination: true,
      tableId: this.tableKeyEnum.DISCOUNT_LIST,
      perPage: this.paginationData.rowsPerPage,
      pageNumber:this.paginationData.pageNumber - 1,
      pageSizeOptions: [5, 10, 15, 20, 50, 100],
      serverSideSortPagination: true,
      serverSideFilter: true,
      pageTotalLength: 0,
      sort: true,
      defaultSortCol: '',
      defaultSortDirection: 'asc',
      // enableMultiDelete: true,
      columns: this.allColumns,
      deleteMsgBoxTitle: 'Are you sure to delete this Discount ?',
      deleteMsgBoxDetail: 'Discount Name :${name} ',
    };
    if (this.discountNeoGridSettings.serverSideSortPagination && this.discountNeoGridSettings.perPage) {
      this.setPaginationPerPage(this.discountNeoGridSettings.perPage);
    }
  }

  ngOnInit() {
    this.setDefaultPageSize(this.tableKeyEnum.DISCOUNT_LIST)
    this.setGridSetting();
    this.initPaginationSort();
    const filterSubscription = this.searchService.getFilterOptions().subscribe((obj) => {
      // if (obj && obj.filters) {
      this.applyFilter(obj);
      // }else
    });
    this.subscriptions.push(filterSubscription);
  }

  applyFilter(filterObj) {
    let filteredDataForGrid = JSON.parse(JSON.stringify(this.discountDataForGrid.content));
    let filters = filterObj && filterObj.filters ? JSON.parse(JSON.stringify(filterObj.filters)) : null;
    if (this.discountNeoGridSettings.serverSideFilter) {
      this.onFilterChange(filters);
      } else {
           if (!filters) {
              filteredDataForGrid = this.searchService.getFilteredData(filters, this.discountNeoGridSettings);
              this.refreshDataSource(filteredDataForGrid);
           }
       }
    this.refreshDataSource(filteredDataForGrid);
  }

  ngAfterViewInit() {
    this.allColumns.forEach((col) => {
      if (col.colKey == 'status') {
        col.customControls = [this.statusWrapperRef];
      }
      if (col.colKey == 'actionCol') {
        col.customControls = [this.actionBtnRef];
      }
      if (col.colKey == 'name') {
        col.customControls = [this.discountNameReff];
      }
    });
  }

  refreshDataSource(data) {
    if (data) {
      this.dataSource = new MatTableDataSource(JSON.parse(JSON.stringify(data)));
    }
  }

   // onEdit(event) {
  //   this.setUpdateValueInForm(event.RowData);
  // }

  onEdit(event) {
    ////console.log(event);
    this.setUpdateValueInForm(event);
  }

  // onDelete(event) {
  //   let self = this;
  //   if (event.deletClicked) {
  //     self.delete(event.RowData);
  //   }
  // }

  onDelete(event) {
     if (event) {
       this.commonDeleteMsgBox(this.discountNeoGridSettings,event,this.delete.bind(this));
     }
  }

  getDiscountData(gridSetting : any) {
    let fetchSettingData = this.discountNeoGridSettings.serverSideSortPagination ? gridSetting : null;
    let params = this.getGridSettingInfo(fetchSettingData);
    this.discountService.getDiscountDataWithPageing(params).subscribe(result => {
      this.discountDataForGrid = result;
      this.filteredDiscountDataForGrid = JSON.parse(JSON.stringify(this.discountDataForGrid.content));
      this.refreshDataSource(this.discountDataForGrid.content);
      this.totalRecords = result.pageDetails ? result.pageDetails.totalRecords : 0;
      this.discountNeoGridSettings.pageTotalLength = this.totalRecords;
    });
  }

  getListWithParams() {
    if(Array.isArray(this.searchData)){
      if(this.searchData.length > 0){
        if(this.searchData[0].filterValue && this.searchData[0].filterValue !== ''){
          this.paginationData.pageNumber = 1;
        }
      }
    }
    let config = { page: this.paginationData, order: this.orderingData, search: this.searchData };
    this.getDiscountData(config);
  }

  delete(objEvent) {
    let self = this;
    let selected_discount_data = objEvent.event;
    if (objEvent.deleteClicked) {
    this.discountService.deleteDiscount(selected_discount_data.discount_id).subscribe((result) => {
if(result.status !== 200){
  this.tosterservice.error(result.ERROR)
}
else{
  self.discountDataForGrid.content.forEach(function(item, index) {
    if (item.discount_id === selected_discount_data.discount_id) {
      self.discountDataForGrid.content.splice(index, 1);
    }
  });
  this.tosterservice.success('Discount is deleted successfully');
  self.refreshDataSource(self.discountDataForGrid.content);
}

    },
    err => {
      this.tosterservice.error(err.error.status + " " + err.error.ERROR);
    });
   }
  }

  setUpdateValueInForm(rowData) {
    this.router.navigate(['plan-management/discount/add-discount',rowData.discount_id]);
 }

 onAddDiscountClick() {
  this.router.navigate(['plan-management/discount/add-discount']);
 }

 ngOnDestroy() {
  if (this.subscriptions.length > 0) {
    this.subscriptions.map((subscription) => {
      subscription.unsubscribe();
    });
  }
}
setPagination(event){
  let config = { page: event, order: this.orderingData, search: this.searchData };
  this.getDiscountData(config);
    }
}
